import {
  Avatar,
  Box,
  Flex,
  FormLabel,
  Icon,
  Select,
  SimpleGrid,
  useColorModeValue,
} from '@chakra-ui/react';

// Assets
import Usa from 'assets/img/dashboards/usa.png';
// Custom components
import MiniCalendar from 'components/calendar/MiniCalendar';
import MiniStatistics from 'components/card/MiniStatistics';
import IconBox from 'components/icons/IconBox';
import React, { useEffect } from 'react';
import {
  MdAddTask,
  MdAttachMoney,
  MdBarChart,
  MdFileCopy,
} from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { masterDashboard } from '../../../redux/actions/Admin.action';
import { getTodaySales } from '../../../redux/actions/Report.action'; // Add this import
import BarChart from 'components/charts/BarChart';
import {
  LuIndianRupee,
  LuUserPlus,
  LuUsers,
  LuActivity,
  LuUserCog,
  LuSyringe,
  LuLayoutGrid,
  LuCross,
} from 'react-icons/lu';
import { FaHome } from 'react-icons/fa';
import { FaHospitalUser } from 'react-icons/fa';
import { FaUserDoctor, FaUserGroup } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { LuFileCheck, LuFileX } from 'react-icons/lu';
import LeadChart from 'components/charts/LeadChart';
// import Msg from 'components/Msg/Msg';
import { MdMessage } from 'react-icons/md';
// import SideDrawer from 'components/chat/SideDrawer';
export default function UserReports() {
  // Chakra Color Mode
  const brandColor = useColorModeValue('brand.500', 'white');
  const boxBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.100');

  const [formData, setFormData] = useState({
    date: '',
    startDate: '',
    endDate: '',
  });
  const [showHome, setShowHome] = useState(false);
  const [mainPage, setMainPage] = useState(1); // Add this
  const [rowsPerPage, setRowsPerPage] = useState(10); // Add this

  const dispatch = useDispatch();
  const counts = useSelector((state) => state.admin);
  const CountData = counts?.masterCount?.data;
  const reportData = useSelector((state) => state.report);
  console.log('reportData', reportData);

  // Add this function to calculate total billing amount
  const calculateTotalBilling = (data) => {
    const totalPaid = data?.totalPaid || 0;
    const totalDue = data?.totalDueAmountTillToday || 0;
    return totalPaid + totalDue;
  };

  // Add this function to calculate total full billing amount
  const calculateTotalFullBilling = (data) => {
    const totalPaidFull = data?.totalPaidfull || 0;
    const totalDueFull = data?.totalDueAmountTillTodayfull || 0;
    return totalPaidFull + totalDueFull;
  };

  const limits = { // Add this
    page: mainPage,
    limit: rowsPerPage,
  };
  
  const handleFormData = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === 'startDate' || name === 'endDate' ? { date: '' } : {}),
      ...(name === 'date' ? { startDate: '', endDate: '' } : {}),
    }));
  };

  useEffect(() => {
    let payload = {};
    if (formData.date) {
      payload.date = formData.date;
    }

    if (formData.startDate || formData.endDate) {
      payload.startDate = formData.startDate;
      payload.endDate = formData.endDate;
    }

    if (formData) {
      dispatch(masterDashboard(payload));
      // Add this to fetch the todaySales data
      dispatch(getTodaySales('', limits, payload));
    }
  }, [formData, mainPage, rowsPerPage]);

  const data = {
    labels: ['Total Appointment', 'Confirm Appointment', 'Pending Appointment'],
    datasets: [
      {
        label: 'Appointments',
        data: [
          CountData?.totalAppointments || 0,
          CountData?.confirmedAppointments || 0,
          CountData?.pendingAppointments || 0,
        ],
        backgroundColor: 'rgba(183, 130, 52,0.6)',
        borderColor: 'rgba(183, 130, 52,0.6)',
        borderWidth: 1,
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 2,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Enquiries by Category',
      },
    },
  };

  return (
    <>
      <div className="mt-[100px]">
        <div className="d-flex justify-end items-center gap-3">
          <div className="w-[200px]">
            <label className="text-sm block mb-1">Date</label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleFormData}
              className="w-75 outline-none !border-b"
            />
          </div>
          <div className="w-[200px]">
            <label className="text-sm block mb-1">Start Date</label>
            <input
              type="date"
              name="startDate"
              value={formData.startDate}
              onChange={handleFormData}
              className="w-75 outline-none !border-b"
            />
          </div>
          <div className="w-[200px]">
            <label className="text-sm block mb-1">End Date</label>
            <input
              type="date"
              name="endDate"
              value={formData.endDate}
              onChange={handleFormData}
              className="w-75 outline-none !border-b"
            />
          </div>
        </div>
      </div>
      <Box pt={{ base: '20px', md: '40px', xl: '50px' }}>
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 3, '2xl': 4 }}
          gap="20px"
          mb="20px"
        >
          <Link to="/master/SalesReport">
            <MiniStatistics
            bgColor="#FFE4C4"// Bisque color for Lead card
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<LuIndianRupee className="text-[24px]" />}
                />
              }
              name="Total Today Billing"
              value={CountData?.totalReceived}
            />
          </Link>
          {/* <Link to="/master/SalesReport">
            <MiniStatistics
            bgColor="#F8E8E8" // Light Pink
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<LuIndianRupee className="text-[24px]" />}
                />
              }
              name="Billing Amount"
              value={CountData?.totalPaid + CountData?.totalDueAmountTillToday}
            />
          </Link> */}
          <Link to="/master/SalesReport">
            <MiniStatistics
              bgColor="#F8E8E8" // Light Pink
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<LuIndianRupee className="text-[24px]" />}
                />
              }
              name="Billing Amount"
              value={CountData?.allbillingAmont}
            />
          </Link>
          <Link to="/master/PaidAmountReport">
            <MiniStatistics
            bgColor="#E8F8E8" 
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<LuIndianRupee className="text-[24px]" />}
                />
              }
              name="Received Amount"
              value={CountData?.totalPaid}
            />
          </Link>
          <Link to={'/master/DueAmount'}>
            <MiniStatistics
            bgColor="#F5F5F5" // Light Gray
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<LuIndianRupee className="text-[24px]" />}
                />
              }
              name="Due Amount"
              value={CountData?.totalDueAmountTillToday}
            />
          </Link>
           <Link to="/master/SalesReport">
            <MiniStatistics
              bgColor="#F8E8E8" // Light Pink
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<LuIndianRupee className="text-[24px]" />}
                />
              }
              name="All Billing Amount(*)"
              value={CountData?.allbillingAmontfull}
            />
          </Link>
          <Link to="/master/PaidAmountReport">
            <MiniStatistics
            bgColor="#FAF9F6" // Off White
              startContent={
                <IconBox
                  w='56px'
                  h='56px'
                  className='text-theme-dark bg-[#F7EEE9]'
                  icon={
                    <LuIndianRupee className="text-[24px]" />
                  }
                />
              }
              name='All Received Amount(*)'
              value={CountData?.totalPaidfull}
            />
          </Link>
          <Link to={"/master/DueAmount"}>
            <MiniStatistics
            bgColor="#FFF8DC" // Cream
              startContent={
                <IconBox
                  w='56px'
                  h='56px'
                  className='text-theme-dark bg-[#F7EEE9]'
                  icon={
                    <LuIndianRupee className="text-[24px]" />
                  }
                />
              }
              name='All Due Amount(*)'
              value={CountData?.totalDueAmountTillTodayfull}
            />
          </Link>
          <Link to={'/master/lead'}>
            <MiniStatistics
           bgColor="#F0F8FF" //AliceBlue
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<LuActivity className="text-[24px]" />}
                />
              }
              name="Total Lead"
              value={CountData?.leadsCount}
            />
          </Link>
          <Link to={'/master/addAppointment'}>
            <MiniStatistics
             bgColor="#F5FFFA" // Mint Cream
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<LuUsers className="text-[24px]" />}
                />
              }
              name="Today Appointment"
              value={CountData?.totalAppointments}
            />
          </Link>
          <Link to={'/master/allAppointment/'}>
            <MiniStatistics
          bgColor="#FFF5EE" // Seashell
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<LuUserPlus className="text-[24px]" />}
                />
              }
              name="Confirm Appointment"
              value={CountData?.confirmedAppointments}
            />
          </Link>
          <Link to={'/master/allAppointment/'}>
            <MiniStatistics
           bgColor="#F0FFFF" // Azure
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<LuUserCog className="text-[24px]" />}
                />
              }
              name="Pending Appointment"
              value={CountData?.pendingAppointments}
            />
          </Link>
          <Link to={'/master/Consult'}>
            <MiniStatistics
             bgColor="#F0F0FF" // Lavender Mist
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<LuCross className="text-[24px]" />}
                />
              }
              name="Total Consult"
              value={CountData?.probelmCount}
            />
          </Link>
          <Link to={'/master/diagnosis'}>
            <MiniStatistics
            bgColor="#F5F5FF" // Ghost White
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<LuSyringe className="text-[24px]" />}
                />
              }
              name="Total Diagnosis"
              value={CountData?.diagnosisCount}
            />
          </Link>
          <Link to={'/master/branch'}>
            <MiniStatistics
            bgColor="#F0FFF0"//Honeydew
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<FaHome className="text-[24px]" />}
                />
              }
              name="Total Branch"
              value={CountData?.branchCount}
            />
          </Link>
          <Link to={'/master/care-plans/service'}>
            <MiniStatistics
            bgColor="#FFF0F5" //LavenderBlush
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<LuLayoutGrid className="text-[24px]" />}
                />
              }
              name="Total Service"
              value={CountData?.serviceCount}
            />
          </Link>
          {/* <Link to={"#"}>
          <MiniStatistics
            startContent={
              <IconBox
                w='56px'
                h='56px'
                className='text-theme-dark bg-[#F7EEE9]'
                icon={
                  <Icon w='32px' h='32px' as={MdFileCopy} />
                }
              />
            }
            name='Total Package'
            value={CountData?.packageCount}
          />
          </Link> */}
          <Link to={'/master/adminUser'}>
            <MiniStatistics
           bgColor="#FAF0E6" // Linen
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<FaUserDoctor className="text-[24px]" />}
                />
              }
              name="Total Doctor"
              value={CountData?.doctorCount}
            />
          </Link>
          <Link to={'/master/adminUser'}>
            <MiniStatistics
            bgColor="#F0FFFF" //Azure
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<FaUserGroup className="text-[24px]" />}
                />
              }
              name="Total Counselor"
              value={CountData?.counselorCount}
            />
          </Link>
          <Link to={'/master/adminUser'}>
            <MiniStatistics
            bgColor="#FFF5EE" //Seashell
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<FaHospitalUser className="text-[24px]" />}
                />
              }
              name="Total Receptionist"
              value={CountData?.receptionistCount}
            />
          </Link>
          <Link to={'/master/FileCreated'}>
            <MiniStatistics
            bgColor="#F8F8FF"// (GhostWhite)
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<Icon w="25px" h="25px" as={LuFileCheck} />}
                />
              }
              name="File Created"
              value={CountData?.fileCreatedCount?.fileCreated?.totalRecord}
            />
          </Link>
          <Link to={'/master/FileNotCreated'}>
            <MiniStatistics
            bgColor="#FAFAD2" //LightGoldenrodYellow
              startContent={
                <IconBox
                  w="56px"
                  h="56px"
                  className="text-theme-dark bg-[#F7EEE9]"
                  icon={<Icon w="25px" h="25px" as={LuFileX} />}
                />
              }
              name="File Not Created"
              value={CountData?.fileCreatedCount?.fileNotCreated?.totalRecord}
            />
          </Link>
          
        </SimpleGrid>
      </Box>
      {/* <div className="mt-5 chart-wrapper md:w-[60%] mx-auto">
        <BarChart data={data} options={options} />
      </div> */}
      {/* <Box
        position="fixed"
        bottom="30px"
        right="30px"
        zIndex="999"
        bg="#F7EEE9"
        p="3"
        borderRadius="full"
        boxShadow="lg"
        cursor="pointer"
        _hover={{ bg: '#f0e0d3' }}
      >
        <MdMessage size={24} color="#B78234" />
      </Box> */}

      {/* Conditionally render Home component */}
      {/* {showHome && <Home onClose={() => setShowHome(false)} />} */}
 {/* Message Icon Button */}
 {/* <Box
        position="fixed"
        bottom="30px"
        right="30px"
        zIndex="999"
        bg="#F7EEE9"
        p="3"
        borderRadius="full"
        boxShadow="lg"
        cursor="pointer"
        _hover={{ bg: "#f0e0d3" }}
        onClick={() => setShowHome(true)}
      >
        <MdMessage size={24} color="#B78234" />
      </Box>

      {showHome && (
        <Box
          position="fixed"
          top="0"
          left="0"
          width="100vw"
          height="100vh"
          bg="rgba(0, 0, 0, 0.4)"
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex="1000"
        >
          {/* <Home onClose={() => setShowHome(false)} /> 
          <SideDrawer onClose={() => setShowHome(false)} />
        </Box>
      )} */}
      <Box>
        <LeadChart />
      </Box>
    </>
  );
}
